// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './src/App'
import router from './src/router'
import carousel from '@chenfengyuan/vue-carousel'
import VueCookies from 'vue-cookies'

VueCookies.config('360d')

Vue.config.productionTip = false
Vue.use(carousel)
Vue.use(VueCookies)

Vue.prototype.$staticPath = process.env.STATIC_PATH

// eslint-disable-next-line
new Vue({ 
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = null
// module chunks = 